import React from 'react';
import {useContext} from 'use-context-selector';
import {Alert} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import {LocalContext} from '../context/LocalContext';

const MessageClientStatus = (props) => {
    const [localData, setLocalData] = useContext(LocalContext);

    const handleMessageDestroy = () => {
        const messagesList = [...localData.clientStatusMessages]
        messagesList.splice((messagesList.findIndex(message => message.uuid === props.messageData.uuid)), 1);
        setLocalData({...localData, clientStatusMessages: messagesList});
    }

    return <Alert key={props.messageData.uuid} variant={props.messageData.variant} onClose={handleMessageDestroy} dismissible>
        <style>
            {`p:last-of-type {
                margin-bottom: 0;
            }`}
        </style>
        <>
            {
                props.messageData.message ?
                    <>{props.messageData.message}</> :
                    <Trans i18nKey={`messages-MessageClientStatus.${props.messageData.i18nKey}.message`}/>
            }
        </>

        {
            props.messageData.source ?
                <>
                    <p
                        className="mb-0"
                    >
                        <small>
                            <Trans
                                i18nKey="MessageClientStatus.source"
                            />
                            {' '}
                            <em>
                                {props.messageData.source}
                            </em>
                        </small>
                    </p>
                </> :
                null
        }
    </Alert>
}

export default MessageClientStatus;
